import { render, staticRenderFns } from "./DescargoEstadoPage.vue?vue&type=template&id=37b96d3c"
import script from "./DescargoEstadoPage.js?vue&type=script&lang=js&external"
export * from "./DescargoEstadoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports